import MuiTableContainer from '@material-ui/core/TableContainer'
import MuiTable from '@material-ui/core/Table'
import MuiTableHead from '@material-ui/core/TableHead'
import MuiTableRow from '@material-ui/core/TableRow'
import MuiTableBody from '@material-ui/core/TableBody'
import React from 'react'
import HeaderCell from './HeaderCell'
import TableRow from './TableRow'
import TableCell from 'components/dealwatch/TableCell'

const Table = ({
  deals,
  compareParams,
  getParam,
  sortBy,
  sortOrder,
  handleRemoveDeal,
  parameter,
  short
}) => ( // setting key explicitly for readability but mostly the linter
  <MuiTableContainer>
    <MuiTable>
      <MuiTableHead classes={{ root: 'bg-white' }}>
        <MuiTableRow>
          <TableCell cxNames='b pv6 white bg-dark-sea-green-3 relative'>
            <div className='w-max-content max-w13'>Deal name</div>
          </TableCell>
          {compareParams.map((paramName, index) => (
            <HeaderCell
              key={index}
              {...{
                paramName,
                getParam,
                sortBy,
                sortOrder,
                short,
                compareParams
              }}
            />
          ))}
        </MuiTableRow>
      </MuiTableHead>
      <MuiTableBody className='bg-white'>
        {deals.map(deal => {
          const { dealId, length: dealCount } = deal

          return (
            <TableRow
              key={dealId}
              {...{
                deal,
                compareParams,
                handleRemoveDeal,
                parameter,
                dealCount
              }}
            />
          )
        })}
      </MuiTableBody>
    </MuiTable>
  </MuiTableContainer>
)

export default Table
